const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <div className="uberall-locations__pagination">
      <button
        onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
        disabled={currentPage === 1}
        className="uberall-locations__pagination-btn"
      >
        Zurück
      </button>
      <span className="uberall-locations__pagination-info">
        Seite {currentPage} von {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
        className="uberall-locations__pagination-btn"
      >
        Weiter
      </button>
    </div>
  );
};

export default Pagination;
